// Lightweight guide metadata for menus/footers — the full texts stay in the lazy-loaded page chunk (see index.js).
export const GUIDE_SLUGS = ['velika-plaza', 'ada-bojana', 'airport-to-ulcinj', 'ulcinj-old-town', 'ulcinj-salt-flats'];

// Short menu label per language
export const GUIDES_NAV_LABEL = { en: 'Guides', me: 'Vodiči', sq: 'Udhëzues', de: 'Reisetipps', pl: 'Przewodniki', ru: 'Путеводители', hu: 'Útikalauz', ro: 'Ghiduri' };

export const GUIDE_LABELS = {
  en: {
    title: 'Ulcinj travel guides',
    sub: 'Local tips from the Hotel Uma Premium team — beaches, day trips and how to get here.',
    read: 'Read the guide',
    facts: 'Quick facts',
    faq: 'Good to know',
    map: 'On the map',
    back: 'All guides',
    plan: 'Plan your stay in Ulcinj',
    cta: 'Check rooms & prices',
    distance: 'Distance from the hotel',
    more: 'More guides'
  },
  me: {
    title: 'Vodiči kroz Ulcinj',
    sub: 'Lokalni savjeti tima Hotela Uma Premium — plaže, izleti i kako doći do nas.',
    read: 'Pročitaj vodič',
    facts: 'Ukratko',
    faq: 'Dobro je znati',
    map: 'Na mapi',
    back: 'Svi vodiči',
    plan: 'Planirajte boravak u Ulcinju',
    cta: 'Pogledaj sobe i cijene',
    distance: 'Udaljenost od hotela',
    more: 'Još vodiča'
  },
  sq: {
    title: 'Udhëzues turistikë për Ulqinin',
    sub: 'Këshilla lokale nga ekipi i Hotel Uma Premium — plazhe, ekskursione dhe si të vini.',
    read: 'Lexo udhëzuesin',
    facts: 'Shkurt',
    faq: 'Mirë të dihet',
    map: 'Në hartë',
    back: 'Të gjithë udhëzuesit',
    plan: 'Planifikoni qëndrimin në Ulqin',
    cta: 'Shiko dhomat dhe çmimet',
    distance: 'Largësia nga hoteli',
    more: 'Udhëzues të tjerë'
  },
  de: {
    title: 'Reiseführer Ulcinj',
    sub: 'Tipps vom Team des Hotel Uma Premium — Strände, Ausflüge und Anreise.',
    read: 'Guide lesen',
    facts: 'Kurz & knapp',
    faq: 'Gut zu wissen',
    map: 'Auf der Karte',
    back: 'Alle Guides',
    plan: 'Planen Sie Ihren Aufenthalt in Ulcinj',
    cta: 'Zimmer & Preise ansehen',
    distance: 'Entfernung vom Hotel',
    more: 'Weitere Guides'
  },
  pl: {
    title: 'Przewodniki po Ulcinju',
    sub: 'Lokalne wskazówki od zespołu Hotelu Uma Premium — plaże, wycieczki i dojazd.',
    read: 'Czytaj przewodnik',
    facts: 'W skrócie',
    faq: 'Warto wiedzieć',
    map: 'Na mapie',
    back: 'Wszystkie przewodniki',
    plan: 'Zaplanuj pobyt w Ulcinju',
    cta: 'Zobacz pokoje i ceny',
    distance: 'Odległość od hotelu',
    more: 'Więcej przewodników'
  },
  ru: {
    title: 'Путеводители по Улциню',
    sub: 'Советы команды Hotel Uma Premium — пляжи, поездки и как добраться.',
    read: 'Читать',
    facts: 'Кратко',
    faq: 'Полезно знать',
    map: 'На карте',
    back: 'Все путеводители',
    plan: 'Спланируйте отдых в Улцине',
    cta: 'Номера и цены',
    distance: 'Расстояние от отеля',
    more: 'Другие путеводители'
  },
  hu: {
    title: 'Ulcinj útikalauzok',
    sub: 'Helyi tippek a Hotel Uma Premium csapatától — strandok, kirándulások és megközelítés.',
    read: 'Útikalauz olvasása',
    facts: 'Gyors tények',
    faq: 'Jó tudni',
    map: 'A térképen',
    back: 'Minden útikalauz',
    plan: 'Tervezze meg ulcinji tartózkodását',
    cta: 'Szobák és árak',
    distance: 'Távolság a hoteltől',
    more: 'További útikalauzok'
  },
  ro: {
    title: 'Ghiduri de călătorie Ulcinj',
    sub: 'Sfaturi locale de la echipa Hotel Uma Premium — plaje, excursii de o zi și cum ajungi aici.',
    read: 'Citește ghidul',
    facts: 'Pe scurt',
    faq: 'Bine de știut',
    map: 'Pe hartă',
    back: 'Toate ghidurile',
    plan: 'Planifică-ți sejurul în Ulcinj',
    cta: 'Vezi camere și prețuri',
    distance: 'Distanța de la hotel',
    more: 'Alte ghiduri'
  }
};

export const GUIDE_TITLES = {
  en: {
    'velika-plaza': 'Velika Plaža (Long Beach) — the complete guide',
    'ada-bojana': 'Ada Bojana — river island, kitesurfing and fish restaurants',
    'airport-to-ulcinj': 'How to get from the airport to Ulcinj',
    'ulcinj-old-town': 'Ulcinj Old Town (Stari Grad) & Mala Plaža — what to see',
    'ulcinj-salt-flats': 'Ulcinj Salt Flats (Solana) — flamingos and birdwatching'
  },
  me: {
    'velika-plaza': 'Velika plaža — kompletan vodič',
    'ada-bojana': 'Ada Bojana — riječno ostrvo, kajtsurfing i riblji restorani',
    'airport-to-ulcinj': 'Kako doći od aerodroma do Ulcinja',
    'ulcinj-old-town': 'Stari grad Ulcinj i Mala plaža — šta vidjeti',
    'ulcinj-salt-flats': 'Ulcinjska solana — flamingosi i posmatranje ptica'
  },
  sq: {
    'velika-plaza': 'Plazhi i Madh (Velika Plaža) — udhëzuesi i plotë',
    'ada-bojana': 'Ada e Bunës (Ada Bojana) — ishull lumor, kitesurf dhe restorante peshku',
    'airport-to-ulcinj': 'Si të vini nga aeroporti në Ulqin',
    'ulcinj-old-town': 'Kalaja e Ulqinit dhe Plazhi i Vogël — çfarë të shihni',
    'ulcinj-salt-flats': 'Kriporja e Ulqinit (Solana) — flamingot dhe vrojtimi i shpendëve'
  },
  de: {
    'velika-plaza': 'Velika Plaža (Langer Strand) — der komplette Guide',
    'ada-bojana': 'Ada Bojana — Flussinsel, Kitesurfen und Fischrestaurants',
    'airport-to-ulcinj': 'Vom Flughafen nach Ulcinj',
    'ulcinj-old-town': 'Altstadt von Ulcinj (Stari Grad) & Mala Plaža — was man sehen sollte',
    'ulcinj-salt-flats': 'Salinen von Ulcinj (Solana) — Flamingos und Vogelbeobachtung'
  },
  pl: {
    'velika-plaza': 'Velika Plaža (Długa Plaża) — kompletny przewodnik',
    'ada-bojana': 'Ada Bojana — wyspa na rzece, kitesurfing i restauracje rybne',
    'airport-to-ulcinj': 'Jak dojechać z lotniska do Ulcinja',
    'ulcinj-old-town': 'Stare Miasto w Ulcinju (Stari Grad) i Mala Plaža — co zobaczyć',
    'ulcinj-salt-flats': 'Saliny w Ulcinju (Solana) — flamingi i obserwacja ptaków'
  },
  ru: {
    'velika-plaza': 'Велика Плажа (Большой пляж) — полный гид',
    'ada-bojana': 'Ада-Бояна — речной остров, кайтсёрфинг и рыбные рестораны',
    'airport-to-ulcinj': 'Как добраться из аэропорта в Улцинь',
    'ulcinj-old-town': 'Старый город Улциня (Стари-Град) и Мала-Плажа — что посмотреть',
    'ulcinj-salt-flats': 'Улциньская солана (Solana) — фламинго и наблюдение за птицами'
  },
  hu: {
    'velika-plaza': 'Velika Plaža (Hosszú strand) — a teljes útikalauz',
    'ada-bojana': 'Ada Bojana — folyami sziget, kitesurf és halvendéglők',
    'airport-to-ulcinj': 'Hogyan jussunk el a repülőtérről Ulcinjba',
    'ulcinj-old-town': 'Ulcinj óvárosa (Stari Grad) és a Mala Plaža — mit érdemes látni',
    'ulcinj-salt-flats': 'Ulcinji sópárló (Solana) — flamingók és madárles'
  },
  ro: {
    'velika-plaza': 'Velika Plaža (Plaja Lungă) — ghidul complet',
    'ada-bojana': 'Ada Bojana — insulă pe râu, kitesurfing și restaurante cu pește',
    'airport-to-ulcinj': 'Cum ajungi de la aeroport la Ulcinj',
    'ulcinj-old-town': 'Orașul Vechi Ulcinj (Stari Grad) și Mala Plaža — ce să vezi',
    'ulcinj-salt-flats': 'Salinele din Ulcinj (Solana) — flamingo și birdwatching'
  }
};

// Visible freshness / authorship line on each guide (E-E-A-T signal for search and answer engines)
export const GUIDE_BYLINE = {
  en: { updated: 'Updated', by: 'by the Hotel Uma Premium team' },
  me: { updated: 'Ažurirano', by: 'tim Hotela Uma Premium' },
  sq: { updated: 'Përditësuar', by: 'nga ekipi i Hotel Uma Premium' },
  de: { updated: 'Aktualisiert', by: 'vom Team des Hotels Uma Premium' },
  pl: { updated: 'Aktualizacja', by: 'zespół Hotelu Uma Premium' },
  ru: { updated: 'Обновлено', by: 'команда отеля Uma Premium' },
  hu: { updated: 'Frissítve', by: 'a Hotel Uma Premium csapata' },
  ro: { updated: 'Actualizat', by: 'de echipa Hotel Uma Premium' },
};

export const guideLabels = (lang) => GUIDE_LABELS[lang] || GUIDE_LABELS.en;
export const guideTitle = (lang, slug) => (GUIDE_TITLES[lang] || GUIDE_TITLES.en)[slug];
